/* eslint-disable @typescript-eslint/no-explicit-any */
import { defineComponent, ref, computed, PropType } from "vue";

export default defineComponent({
  name: "c-filter-button",

  props: {
    loading: { type: Boolean, default: false },
    style: { type: String, default: "" },
    class: { type: String, default: "" },
    schema: { type: Function as PropType<() => void>, default: () => ({}) },
  },

  emits: ["enter", "onOptions"],

  setup(props) {
    const className = ref<string>(props.class);
    const styleName = ref<string>(props.style);
    const isDropdown = ref<boolean>(false);
    const refIds = "cFilterButtonDropdown";

    const onFilterValue = (): void => {
      isDropdown.value = false;
      props.schema();
    };

    const outsideClick = (): void => {
      isDropdown.value = false;
    };

    const isLoading = computed(() => {
      return !!props.loading;
    });

    const onFilter = (): void => {
      isDropdown.value = !isDropdown.value;
    };

    const focusIn = (): void => {
      isDropdown.value = true;
    };

    const focusOut = (): void => {
      isDropdown.value = false;
    };

    const handleKeyDown = (event: KeyboardEvent): void => {
      if (event.key === "Escape") {
        isDropdown.value = false;
      }
    };

    return {
      refIds,
      className,
      styleName,
      isLoading,
      onFilter,
      isDropdown,
      onFilterValue,
      outsideClick,
      focusIn,
      focusOut,
      handleKeyDown,
    };
  },
});
